const initials = "product/";
export const SET_CURRENT_PRODUCT_DETAIL = `${initials}SET_CURRENT_PRODUCT_DETAIL`;
export const REMOVE_CURRENT_PRODUCT_DETAIL = `${initials}REMOVE_CURRENT_PRODUCT_DETAIL`;

